var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 357,
    viewBox: "0 0 251 357",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.798 47.1117H79.8857V120.448H134.798V47.1117Z",
    fill: "#C2CFE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.895 45.1887H81.9824V118.525H136.895V45.1887Z",
    stroke: "#008ECA",
    strokeWidth: 0.473381,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.221 75.7408V91.9844L126.182 89.3913C125.461 89.3913 121.62 115.238 121.62 115.238H95.1103C95.1103 115.238 91.2683 89.3913 90.5488 89.3913L85.9097 91.8225V75.4237C85.9097 71.5249 94.9219 69.2129 97.6363 67.7255C102.062 65.2999 103.144 62.1633 103.024 59.1621H103.196L103.02 59.1289C102.452 55.5426 101.12 54.5314 101.093 50.9735H118.115C117.86 53.9388 117.699 57.0224 115.62 59.1933C115.186 59.6459 114.315 59.892 113.224 60.0018C113.318 62.8667 114.911 66.1283 119.083 67.7217C122.634 69.0775 131.221 72.4433 131.221 75.7408Z",
    fill: "#C2CFE0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.57 71.5249C109.984 71.5249 109.579 84.7351 110.273 89.7122C110.787 93.3923 119.191 95.3928 120.527 93.6782C123.593 89.7387 117.493 71.5249 112.57 71.5249Z",
    fill: "#C2CFE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.592 71.5249C107.178 71.5249 107.584 84.7351 106.889 89.7122C106.375 93.3923 97.822 95.5007 96.6348 93.6782C93.4035 88.7191 99.6635 71.5249 104.592 71.5249Z",
    fill: "#C2CFE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.976 96.6813C113.038 95.4032 107.259 93.8505 100.159 95.9561C94.6731 97.5817 96.3347 106.242 98.6202 106.224C99.7563 106.215 100.522 103.826 102.723 103.857C108.106 103.94 110.73 101.923 111.259 98.555C111.459 97.2778 112.926 97.7057 112.976 96.6813Z",
    fill: "#C2CFE0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.635 103.394C109.337 104.684 117.51 104.018 118.527 100.152C119.426 96.7305 115.903 95.9958 114.219 97.7094C113.027 98.9222 113.124 99.2915 112.181 101.004C111.041 103.068 109.796 102.681 109.635 103.394Z",
    fill: "#C2CFE0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.792 102.163C117.845 103.417 116.402 104.325 114.948 104.86C113.266 105.48 111.591 105.489 109.808 105.428C106.245 105.309 101.998 104.878 99.4013 107.849C98.1317 109.303 97.3913 111.226 97.5494 113.168C97.5996 113.777 98.0342 114.299 98.6856 114.299C99.2536 114.299 99.8652 113.78 99.816 113.168C99.7531 112.489 99.8298 111.805 100.041 111.156C100.253 110.508 100.595 109.91 101.047 109.399C102.109 108.212 103.543 107.744 105.175 107.652C108.718 107.455 112.43 108.278 115.824 106.937C117.784 106.162 119.472 104.993 120.747 103.303C121.115 102.815 120.825 102.039 120.341 101.756C119.761 101.417 119.163 101.673 118.795 102.162L118.792 102.163Z",
    fill: "#C2CFE0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7765 47.1117H7.86426V120.448H62.7765V47.1117Z",
    fill: "#C2CFE0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8746 45.1887H9.9624V118.525H64.8746V45.1887Z",
    stroke: "#008ECA",
    strokeWidth: 0.473381,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1567 72.4432C33.1887 72.4432 38.0786 67.5533 38.0786 61.5213C38.0786 55.4894 33.1887 50.5995 27.1567 50.5995C21.1247 50.5995 16.2349 55.4894 16.2349 61.5213C16.2349 67.5533 21.1247 72.4432 27.1567 72.4432Z",
    fill: "#EDF0ED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2915 51.8795L27.1562 61.5213V50.5985C28.9469 50.596 30.7104 51.0353 32.2905 51.8776L32.2915 51.8795Z",
    fill: "#A4D5EE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0791 61.5214H27.1562L32.2915 51.8795C34.0398 52.8108 35.5019 54.2 36.5214 55.8984C37.5409 57.5968 38.0793 59.5405 38.0791 61.5214V61.5214Z",
    fill: "#008ECA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0794 61.5214C38.0795 63.7012 37.4273 65.8312 36.2067 67.6373C34.9861 69.4434 33.2529 70.8429 31.2303 71.6557C29.2077 72.4686 26.9881 72.6576 24.8571 72.1985C22.7262 71.7393 20.7814 70.653 19.2729 69.0794V69.0794L27.1585 61.5233L38.0794 61.5214Z",
    fill: "#CFB9DF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1565 61.5214L19.2709 69.0775C18.6727 68.4543 18.1505 67.7625 17.7153 67.0164L27.1565 61.5214Z",
    fill: "#653D85"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.98 57.0942L39.083 53.3829H43.2583",
    stroke: "#EDF0ED",
    strokeWidth: 0.473381,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M33.98 65.299L43.2185 71.1859",
    stroke: "#EDF0ED",
    strokeWidth: 0.473381,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4677 79.1888H36.5767V109.111H58.4677V79.1888Z",
    fill: "#EDF0ED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4681 112.011H16.2349V113.83H58.4681V112.011Z",
    fill: "#EDF0ED"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.98 79.1888H16.2349V81.3929H33.98V79.1888Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M33.98 83.8091H16.2349V86.0131H33.98V83.8091Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.98 88.4283H16.2349V90.6324H33.98V88.4283Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.98 93.0486H16.2349V95.2527H33.98V93.0486Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.98 97.6687H16.2349V99.8728H33.98V97.6687Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.98 102.288H16.2349V104.492H33.98V102.288Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.98 106.908H16.2349V109.112H33.98V106.908Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4677 51.8795H44.2095V53.3016H58.4677V51.8795Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4677 54.2009H44.2095V55.623H58.4677V54.2009Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9043 56.5225H44.2095V57.9445H53.9043V56.5225Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4677 71.8098H44.2095V73.2319H58.4677V71.8098Z",
    fill: "#C2CFE0"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4677 74.1313H44.2095V75.5534H58.4677V74.1313Z",
    fill: "#C2CFE0"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M185.361 331.719C185.361 331.719 188.975 339.225 186.492 341.933H154.648C154.648 341.933 154.826 336.678 162.493 335.848C169.376 335.105 173.568 331.713 173.568 331.713L185.361 331.719Z",
    fill: "#008ECA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M154.345 343.826H186.921C187.194 343.826 187.415 343.605 187.415 343.333V342.432C187.415 342.16 187.194 341.939 186.921 341.939H154.345C154.072 341.939 153.852 342.16 153.852 342.432V343.333C153.852 343.605 154.072 343.826 154.345 343.826Z",
    fill: "#214E92"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M169.278 336.519L168.241 334.045C168.212 333.98 168.17 333.921 168.118 333.873C168.065 333.825 168.003 333.788 167.936 333.765C167.841 333.731 167.738 333.725 167.64 333.747C167.542 333.769 167.451 333.819 167.38 333.89C167.308 333.961 167.258 334.051 167.235 334.149C167.213 334.247 167.218 334.35 167.251 334.445L167.262 334.481L167.352 334.824L166.462 335.057L166.377 334.73C166.267 334.398 166.28 334.038 166.413 333.715C166.546 333.392 166.79 333.128 167.102 332.97C167.278 332.881 167.47 332.829 167.667 332.817C167.864 332.805 168.061 332.833 168.246 332.9C168.432 332.966 168.602 333.069 168.747 333.204C168.891 333.338 169.007 333.5 169.086 333.68L170.127 336.164L169.278 336.519Z",
    fill: "#214E92"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M164.72 337.855L164.04 335.353C164.018 335.285 163.984 335.222 163.937 335.167C163.891 335.112 163.834 335.068 163.77 335.035C163.706 335.003 163.636 334.984 163.564 334.979C163.493 334.975 163.421 334.984 163.353 335.008C163.048 335.115 162.905 335.397 162.949 335.806L162.037 335.905C161.945 335.066 162.334 334.39 163.05 334.14C163.236 334.075 163.434 334.048 163.63 334.062C163.827 334.075 164.019 334.129 164.194 334.219C164.37 334.309 164.525 334.434 164.651 334.586C164.776 334.738 164.869 334.914 164.925 335.104L165.608 337.618L164.72 337.855Z",
    fill: "#214E92"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M138.708 331.719C138.708 331.719 142.322 339.225 139.84 341.933H107.996C107.996 341.933 108.173 336.678 115.84 335.848C122.723 335.105 126.916 331.713 126.916 331.713L138.708 331.719Z",
    fill: "#008ECA"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M107.694 343.826H140.27C140.543 343.826 140.764 343.605 140.764 343.333V342.432C140.764 342.16 140.543 341.939 140.27 341.939H107.694C107.422 341.939 107.201 342.16 107.201 342.432V343.333C107.201 343.605 107.422 343.826 107.694 343.826Z",
    fill: "#214E92"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M122.626 336.519L121.589 334.044C121.533 333.918 121.43 333.818 121.301 333.766C121.172 333.713 121.029 333.713 120.9 333.765C120.771 333.818 120.668 333.918 120.612 334.044C120.556 334.171 120.551 334.315 120.599 334.445L120.61 334.481L120.7 334.824L119.81 335.056L119.725 334.73C119.607 334.375 119.629 333.989 119.788 333.651C119.947 333.312 120.23 333.048 120.578 332.913C120.927 332.778 121.314 332.782 121.659 332.925C122.005 333.068 122.282 333.338 122.433 333.68L123.473 336.164L122.626 336.519Z",
    fill: "#214E92"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M118.068 337.855L117.387 335.354C117.366 335.285 117.33 335.222 117.284 335.168C117.238 335.113 117.181 335.068 117.117 335.036C117.053 335.004 116.983 334.985 116.911 334.98C116.84 334.975 116.768 334.985 116.701 335.008C116.396 335.115 116.253 335.398 116.297 335.806L115.382 335.905C115.291 335.066 115.681 334.39 116.397 334.141C116.583 334.075 116.781 334.048 116.978 334.062C117.174 334.076 117.366 334.129 117.542 334.219C117.717 334.309 117.872 334.434 117.998 334.586C118.123 334.738 118.217 334.914 118.272 335.104L118.954 337.618L118.068 337.855Z",
    fill: "#214E92"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M187.13 331.635C175.589 333.459 170.902 331.432 170.902 331.432C170.902 331.432 154.951 240.095 146.246 192.258L143.936 191.059C143.936 191.059 142.783 248.758 145.93 270.418C149.089 292.14 142.224 331.702 142.224 331.702C132.26 333.25 122.732 331.702 122.732 331.702C122.732 331.702 120.609 287.209 117.293 254.166C115.468 235.992 113.153 168.816 113.305 164.368L140.905 164.195L153.162 164.118L173.628 164.003L177.556 163.981C177.839 173.294 179.021 245.362 187.331 265.604C195.741 286.122 187.13 331.635 187.13 331.635Z",
    fill: "#214E92"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M156.49 73.8906C159.086 73.8906 183.703 78.7946 183.673 89.5141C183.648 101.255 171.177 139.918 172.203 147.008C173.229 154.098 179.91 163.467 176.833 164.817C168.548 168.45 140.882 171.335 113.229 164.281C113.229 164.281 116.115 157.768 111.142 129.48C108.441 114.045 107.812 84.522 110.117 81.436C112.423 78.35 126.354 75.1806 131.46 74.2347C136.567 73.2888 156.49 73.8906 156.49 73.8906Z",
    fill: "#214E92"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M155.306 73.8025C154.691 77.3568 148.256 157.946 157.035 198.044C157.035 198.044 171.277 199.991 185.857 194.515C185.857 194.515 177.583 144.112 177.067 135.717C176.552 127.321 182.991 84.0945 179.093 81.7124C166.15 73.8025 155.306 73.8025 155.306 73.8025Z",
    fill: "#9BBAE8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M130.893 74.3556C130.893 74.3556 132.482 150.903 132.912 197.653C132.912 197.653 118.857 201.171 106.733 195.695C106.733 195.695 111.497 139.107 111.566 131.9C111.635 124.692 107.896 82.0487 111.99 79.8787C120.806 75.2057 130.893 74.3556 130.893 74.3556Z",
    fill: "#9BBAE8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4749 152.211C112.872 151.651 126.182 74.978 114.512 78.8905C112.669 79.508 107.254 81.7283 103.544 84.8505C96.4327 90.8356 90.2402 111.844 87.1228 124.098C74.1061 118.458 55.8978 112.975 52.7112 112.13C48.8898 111.116 43.4783 122.61 45.7409 125.957C47.6076 128.71 69.1062 152.982 94.4749 152.211Z",
    fill: "#9BBAE8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M110.521 136.075C111.373 130.759 109.689 122.059 109.341 109.43",
    stroke: "#EDF0ED",
    strokeWidth: 1.13605,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4689 122.222C46.7294 121.877 39.8896 119.314 38.224 117.804C36.5584 116.294 34.654 110.4 34.6493 109.749C34.6446 109.099 34.291 105.306 34.291 105.306C34.291 105.306 37.1759 105.343 38.4518 107.663C40.1488 110.753 41.3493 112.062 43.1814 112.509C43.9435 112.692 45.4708 113.352 45.6374 112.125C45.804 110.898 42.798 109.91 42.245 109.166C41.398 108.03 41.8144 106.42 41.8144 106.42C41.8144 106.42 46.2816 107.887 47.1396 108.166C47.9975 108.444 53.0178 111.734 54.0627 115.692C54.7022 118.123 51.6351 122.851 48.4689 122.222Z",
    fill: "#E18C32"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7978 97.1068L193.699 157.022L180.825 185.577L47.9241 125.664C47.5319 125.49 47.1803 125.236 46.8921 124.919C46.6039 124.601 46.3854 124.226 46.2507 123.819L42.918 113.221L48.1583 101.593L58.312 97.0786C58.7054 96.9094 59.1298 96.8246 59.5579 96.8294C59.9861 96.8343 60.4084 96.9288 60.7978 97.1068Z",
    fill: "#EDF0ED",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8541 97.078L27.4043 102.511L39.7261 108.067L42.1758 102.634L29.8541 97.078Z",
    fill: "#EDF0ED",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8544 109.847L42.9324 100.803C43.1461 100.329 43.5395 99.9591 44.0259 99.775C44.5123 99.5909 45.0519 99.6076 45.5261 99.8213L48.5943 101.205L42.9043 113.824L39.836 112.441C39.3619 112.227 38.9921 111.834 38.808 111.347C38.6239 110.861 38.6406 110.321 38.8544 109.847V109.847Z",
    fill: "#EDF0ED",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2304 104.412L54.3398 121.912L195.712 185.655L203.603 168.155L62.2304 104.412Z",
    fill: "#A4D5EE",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M194.623 155L179.908 187.633C179.614 188.287 179.905 189.055 180.558 189.35L181.191 189.635C181.845 189.93 182.613 189.639 182.908 188.986L197.622 156.352C197.917 155.699 197.626 154.93 196.972 154.635L196.339 154.35C195.686 154.055 194.917 154.346 194.623 155Z",
    fill: "#EDF0ED",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3553 117.407L54.8921 102.909C55.1223 102.398 55.546 102 56.0698 101.802C56.5936 101.604 57.1748 101.622 57.6853 101.852L62.4124 103.983L54.1376 122.335L49.4105 120.204C49.1574 120.09 48.9292 119.927 48.7391 119.725C48.549 119.522 48.4007 119.284 48.3026 119.024C48.2046 118.764 48.1588 118.488 48.1679 118.21C48.1769 117.933 48.2406 117.66 48.3553 117.407V117.407Z",
    fill: "#214E92"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M205.417 163.962L193.773 189.787C193.433 190.541 193.769 191.428 194.523 191.767L195.253 192.097C196.007 192.437 196.894 192.101 197.234 191.347L208.878 165.522C209.218 164.768 208.883 163.881 208.129 163.541L207.398 163.212C206.644 162.872 205.757 163.208 205.417 163.962Z",
    fill: "#EDF0ED",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0674 114.143L74.0516 103.087",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M77.04 114.558L80.8332 106.145",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6309 120.258L87.615 109.201",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6025 120.673L94.3957 112.259",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1929 126.372L101.177 115.317",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M104.166 126.787L107.959 118.373",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M109.755 132.486L114.741 121.431",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M117.728 132.901L121.521 124.488",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M123.318 138.602L128.303 127.545",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M131.291 139.015L135.084 130.602",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M136.88 144.716L141.864 133.66",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M144.853 145.131L148.646 136.716",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M150.444 150.83L155.428 139.774",
    stroke: "#214E92",
    strokeWidth: 0.947496,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M195.859 145.961C207.808 134.879 194.116 82.9397 176.106 80.699C174.261 80.4696 170.378 81.8665 170.117 93.4627C169.869 104.451 175.146 126.774 176.632 132.846C165.319 138.466 147.563 153.856 144.302 155.666C141.042 157.476 145.717 166.588 149.439 165.722C152.316 165.05 183.679 157.445 195.859 145.961Z",
    fill: "#9BBAE8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M143.324 157.445C143.324 157.445 157.795 143.009 176.593 132.819C176.593 132.819 172.77 118.739 171.491 107.993",
    stroke: "#EDF0ED",
    strokeWidth: 1.13605,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M145.66 165.82C144.021 166.461 136.533 168.598 134.333 168.31C132.133 168.023 128.238 165.373 127.89 164.885C127.543 164.396 126.272 160.243 126.272 160.243C126.272 160.243 127.81 159.046 129.272 161.018C131 163.356 134.245 162.888 136.019 162.275C136.756 162.023 138.261 161.004 137.747 159.99C137.233 158.977 134.237 159.868 133.377 159.589C132.062 159.165 131.715 157.635 131.715 157.635C131.715 157.635 136.034 156.452 136.9 156.221C137.766 155.99 143.132 156.189 146.545 158.123C149.958 160.058 149.452 164.333 145.66 165.82Z",
    fill: "#E18C32"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M150.901 57.7861C150.901 57.7861 149.19 65.7998 155.101 73.9108C155.101 73.9108 144.888 79.137 130.994 74.4404C130.994 74.4404 139.181 71.6215 135.681 58.1208L150.901 57.7861Z",
    fill: "#E18C32"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M150.57 57.7941C150.579 58.3267 150.579 58.7698 150.57 59.092C150.57 59.092 149.966 65.1729 146.835 68.1694C144.399 70.4981 136.855 72.8739 134.407 71.6907C136.414 67.4578 136.865 62.6531 135.68 58.1209L150.57 57.7941Z",
    fill: "#D97802"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M150.747 58.9238C150.747 58.9238 147.513 64.4045 146.058 64.9514C142.444 66.309 136.676 67.4984 134.745 66.5054C133.428 65.8281 133.354 65.7857 131.809 59.0825C130.709 54.2885 131.795 44.4694 132.526 44.053C133.257 43.6366 148.63 42.587 149.41 44.1866C150.189 45.7862 150.808 56.4098 150.747 58.9238Z",
    fill: "#E18C32"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M133.896 53.6521C134.44 53.6521 134.882 53.211 134.882 52.6668C134.882 52.1227 134.44 51.6816 133.896 51.6816C133.352 51.6816 132.911 52.1227 132.911 52.6668C132.911 53.211 133.352 53.6521 133.896 53.6521Z",
    fill: "#343A40"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M142.047 53.6521C142.591 53.6521 143.032 53.211 143.032 52.6668C143.032 52.1227 142.591 51.6816 142.047 51.6816C141.503 51.6816 141.062 52.1227 141.062 52.6668C141.062 53.211 141.503 53.6521 142.047 53.6521Z",
    fill: "#343A40"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M137.66 51.7838L136.29 57.4531H138.568",
    stroke: "#343A40",
    strokeWidth: 0.911356,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M150.65 55.2657C150.65 55.2657 147.784 55.4558 148.585 50.566C149.298 46.2166 148.136 45.3241 142.3 46.9661C137.556 48.3017 130.582 48.044 128.001 44.1378C126.538 41.9206 127.372 41.3503 129.729 39.8952C132.683 38.0757 138.529 34.7099 145.852 36.2608C151.699 37.4959 151.999 42.4093 151.999 42.4093C151.999 42.4093 155.505 41.6237 156.292 45.2864C157.284 49.9044 150.76 59.0007 150.76 59.0007L150.65 55.2657Z",
    fill: "#008ECA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M144.029 46.1066C140.654 48.2184 131.93 49.6121 129.167 46.8608",
    stroke: "#008ECA",
    strokeWidth: 0.757368,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M151.836 42.5822C151.836 42.5822 153.687 40.5867 155.607 41.7761",
    stroke: "#008ECA",
    strokeWidth: 0.757368,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M151.775 58.0627C151.539 59.0055 150.879 60.3269 150.008 61.5526C149.627 62.0947 148.824 63.1411 147.882 63.8577C147.175 66.4676 134.765 68.8858 132.875 65.33C131.147 62.0962 131.404 56.13 131.404 56.13C135.057 53.9883 143.346 55.0929 146.277 56.1583C148.024 55.7615 149.737 55.2299 151.402 54.5681C150.997 54.8483 150.638 55.1903 150.338 55.5816V55.5816C149.05 56.0271 147.739 56.4037 146.41 56.7098C146.748 58.0878 147.618 61.6893 147.848 63.1427C148.487 62.5735 149.055 61.9294 149.54 61.2242C150.035 60.5292 150.465 59.7896 150.822 59.0149C150.984 58.8703 151.353 58.5152 151.775 58.0627Z",
    fill: "#9BBAE8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M150.296 55.6366C150.296 55.6366 152.053 53.1901 153.439 54.7159C154.381 55.7576 150.753 59.0872 150.753 59.0872L150.296 55.6366Z",
    fill: "#E18C32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.c05e080d8b1be10b695973bb624fb079.svg";
export { ForwardRef as ReactComponent };